import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'
import { Message, Segment, Button, Form, Checkbox } from 'semantic-ui-react'
import 'moment-timezone'
import {registerAction} from '../../../../actions/registration.action'
import {Link} from 'react-router'
import {anonAPI} from '../../../../services/api'

const { Field } = Form

class Register extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      success: false,
      isLoading: false,
      hasError: false,
      error: undefined,
      email: '',
      password: '',
      first_name: '',
      last_name: '',
      location: '',
      agreement: false
    }
  }

  handleSubmit (e) {
    e.preventDefault()
    if (!this.state.agreement) {
      this.setState({
        success: false,
        hasError: true,
        password: '',
        error: {message: 'You have to agree to the Terms of Service'},
        isLoading: false
      })
      return
    }
    this.setState({
      isLoading: true
    })
    const form = {
      email: this.state.email,
      password: this.state.password,
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      location: this.state.location
    }
    anonAPI.post('/auth/signup', form)
      .then(response => {
        const {data} = response
        this.setState({
          hasError: false,
          isLoading: false,
          success: true
        })
      })
      .catch(error => {
        this.setState({
          success: false,
          hasError: true,
          password: '',
          error: error,
          isLoading: false
        })
      })
  }
  onChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  clickAgreement(e) {
    this.setState({agreement: !this.state.agreement})
  }

  render () {
    const {hasError, error} = this.state
    let errorNode

    if (hasError) {
      errorNode = <Message negative>{error.message}</Message>
    }

    if (this.state.success) {
      return (
        <Message
          success
        >
          <Message.Content>
            <Message.Header>
              Your user registration was successful
            </Message.Header>
          </Message.Content>
        </Message>
      )
    }
    return (
      <Segment>
        <Form loading={this.state.isLoading} onSubmit={this.handleSubmit.bind(this)}>
          <h2>Sign up</h2>
          {errorNode}
          <Field>
            <label htmlFor='first_name'>First name</label>
            <input name='first_name' id='first_name' value={this.state.first_name} onChange={this.onChange.bind(this)} required />
          </Field>
          <Field>
            <label htmlFor='last_name'>Last name</label>
            <input name='last_name' id='last_name' value={this.state.last_name} onChange={this.onChange.bind(this)} required />
          </Field>
          <Field>
            <label htmlFor='location'>Company name</label>
            <input name='location' id='location' value={this.state.location} onChange={this.onChange.bind(this)} required />
          </Field>
          <Field>
            <label htmlFor='email'>Email</label>
            <input autoFocus type='email' name='email' id='email' value={this.state.email} onChange={this.onChange.bind(this)} required />
          </Field>
          <Field>
            <label htmlFor='password'>Password</label>
            <input type='password' name='password' id='password' value={this.state.password} onChange={this.onChange.bind(this)} required />
          </Field>
          <Field inline>
            <Checkbox style={{paddingTop: '3px'}} checked={this.state.agreement} onClick={this.clickAgreement.bind(this)} name='agreement' />
            <a href='https://www.risqover.com/footer/terms' target='_blank' > I agree to the Terms of Service</a>
          </Field>
          <Button primary type='submit'>Sign up</Button>
          <Link style={{float: 'right'}} className='item' activeClassName='active' to='/auth'>Log in </Link>
        </Form>
      </Segment>
    )
  }
}

Register.propTypes = {
  register: PropTypes.func
}

function mapStateToProps (state) {
  return state.registration
}

export default connect(mapStateToProps, {registerAction})(Register)



// WEBPACK FOOTER //
// ./src/pages/signup/components/register/index.js